import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardContent } from "../ui/card";
import { api } from "../../lib/api";
import {
  FileCheck2, GraduationCap, Laptop, ShieldCheck, Building2, AlertTriangle, Siren, FileWarning,
} from "lucide-react";

const TILES = [
  { key: "pending_policies", label: "Policies to sign", icon: FileCheck2, to: "/portal/policies", color: "text-amber-500" },
  { key: "pending_trainings", label: "Trainings pending", icon: GraduationCap, to: "/portal/trainings", color: "text-blue-500" },
  { key: "device_count", label: "My devices", icon: Laptop, to: "/portal/devices", color: "text-primary" },
  { key: "open_vendor_requests", label: "Open vendor requests", icon: Building2, to: "/portal/vendor-requests", color: "text-purple-500" },
  { key: "open_risk_submissions", label: "Open risk submissions", icon: AlertTriangle, to: "/portal/risks", color: "text-orange-500" },
  { key: "open_incidents", label: "Open incidents", icon: Siren, to: "/portal/incidents", color: "text-red-500" },
  { key: "open_exceptions", label: "Pending exceptions", icon: FileWarning, to: "/portal/exceptions", color: "text-rose-500" },
];

export default function PortalDashboard() {
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/employee-portal/dashboard").then((r) => setData(r.data)); }, []);

  if (!data) return <div className="h-40 rounded-xl bg-muted/40 animate-pulse" />;

  return (
    <div className="space-y-6" data-testid="portal-dashboard">
      <div>
        <h1 className="text-xl font-semibold">Welcome, {data.name?.split(" ")[0] || "there"}</h1>
        <p className="text-[13px] text-muted-foreground mt-1">Here's what needs your attention today.</p>
      </div>

      {!data.has_profile && (
        <Card className="border-amber-400/40 bg-amber-400/5" data-testid="portal-no-profile-warning">
          <CardContent className="p-4 text-[13px] text-amber-600 dark:text-amber-400">
            Your account isn't linked to a people profile yet — Policies will show, but you can't sign them until
            an admin adds you to the people roster in UC Compliance.
          </CardContent>
        </Card>
      )}

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {TILES.map((t) => (
          <Link key={t.key} to={t.to} data-testid={`portal-dashboard-tile-${t.key}`}>
            <Card className="hover:border-primary/50 transition-colors h-full">
              <CardContent className="p-4 flex flex-col gap-2">
                <t.icon className={`w-5 h-5 ${t.color}`} />
                <div className="text-2xl font-semibold tabular-nums">{data[t.key] ?? 0}</div>
                <div className="text-[12px] text-muted-foreground">{t.label}</div>
              </CardContent>
            </Card>
          </Link>
        ))}
        <Card>
          <CardContent className="p-4 flex flex-col gap-2">
            <ShieldCheck className={`w-5 h-5 ${data.mfa_enabled ? "text-emerald-500" : "text-muted-foreground"}`} />
            <div className="text-2xl font-semibold">{data.mfa_enabled ? "On" : "Off"}</div>
            <div className="text-[12px] text-muted-foreground">MFA status</div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
